import {
  listContextQuery,
  useAwaitingFirstSync,
  useRecipeQuota,
  useRecipeSummaries,
} from '@platewell/query';
import { Link } from '@tanstack/react-router';
import { StarIcon } from '../components/favourite-button.js';
import { FirstSyncEmpty } from '../components/first-sync-empty.js';
import { RecipeCard } from '../components/recipe-card.js';

export function FavouritesPage() {
  const context = { kind: 'favourites' } as const;
  const recipes = useRecipeSummaries(listContextQuery(context));
  const awaitingFirstSync = useAwaitingFirstSync() && recipes.length === 0;

  return (
    <>
      <div className="row" style={{ marginBottom: 18 }}>
        <h1>Favourites</h1>
        <span className="spacer" />
        {!awaitingFirstSync && <span className="hint list-count">{recipes.length} recipes</span>}
      </div>

      {awaitingFirstSync ? (
        <FirstSyncEmpty />
      ) : recipes.length === 0 ? (
        <FavouritesGuide />
      ) : (
        <div className="grid">
          {recipes.map((recipe) => (
            <RecipeCard key={recipe.id} recipe={recipe} context={context} />
          ))}
        </div>
      )}
    </>
  );
}

/** Shown until the first favourite: how to add one, with the same star the recipe shows. */
function FavouritesGuide() {
  // A book with no recipes has nothing to open yet, so the first step is adding one.
  const hasRecipes = useRecipeQuota().used > 0;

  return (
    <div className="empty favourites-guide">
      <h2>No favourites yet</h2>
      <p className="hint">Here&rsquo;s how to favourite your first recipe.</p>
      <ol className="favourites-steps">
        <li>
          <span className="favourites-step-number">1</span>
          <span>{hasRecipes ? 'Open any recipe.' : 'Add a recipe and select it.'}</span>
        </li>
        <li>
          <span className="favourites-step-number">2</span>
          <span>
            Tap the star{' '}
            <span className="favourites-star" aria-hidden="true">
              <StarIcon filled={false} size={18} />
            </span>{' '}
            next to its title.
          </span>
        </li>
        <li>
          <span className="favourites-step-number">3</span>
          <span>It shows up here. Tap the star again to remove it.</span>
        </li>
      </ol>
      <Link className="btn primary" to="/">
        {hasRecipes ? 'Browse recipes' : 'Add a recipe'}
      </Link>
    </div>
  );
}
